var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgotPassKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_9584_24078)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 40,
    height: 40,
    rx: 10,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 40,
    height: 40,
    rx: 10,
    fill: "url(#paint0_radial_9584_24078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1801 32.75C17.0801 32.75 16.9701 32.74 16.8801 32.73L14.7101 32.43C13.6701 32.29 12.7301 31.36 12.5701 30.3L12.2701 28.11C12.1701 27.41 12.4701 26.5 12.9701 25.99L17.3601 21.6C16.6501 18.76 17.4701 15.76 19.5601 13.69C22.8001 10.46 28.0701 10.45 31.3201 13.69C32.8901 15.26 33.7501 17.35 33.7501 19.57C33.7501 21.79 32.8901 23.88 31.3201 25.45C29.2201 27.53 26.2301 28.35 23.4101 27.63L19.0101 32.02C18.5901 32.46 17.8401 32.75 17.1801 32.75ZM25.4301 12.76C23.6801 12.76 21.9401 13.42 20.6101 14.75C18.8101 16.54 18.1601 19.16 18.9101 21.6C18.9901 21.87 18.9201 22.15 18.7201 22.35L14.0201 27.05C13.8501 27.22 13.7101 27.66 13.7401 27.89L14.0401 30.08C14.1001 30.46 14.5101 30.89 14.8901 30.94L17.0701 31.24C17.3101 31.28 17.7501 31.14 17.9201 30.97L22.6401 26.26C22.8401 26.06 23.1301 26 23.3901 26.08C25.8001 26.84 28.4301 26.19 30.2301 24.39C31.5101 23.11 32.2201 21.39 32.2201 19.57C32.2201 17.74 31.5101 16.03 30.2301 14.75C28.9301 13.43 27.1801 12.76 25.4301 12.76Z",
    fill: "#F8F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1901 30.54C20.0001 30.54 19.8101 30.47 19.6601 30.32L17.3601 28.02C17.0701 27.73 17.0701 27.25 17.3601 26.96C17.6501 26.67 18.1301 26.67 18.4201 26.96L20.7201 29.26C21.0101 29.55 21.0101 30.03 20.7201 30.32C20.5701 30.47 20.3801 30.54 20.1901 30.54Z",
    fill: "#F8F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 21.75C24.26 21.75 23.25 20.74 23.25 19.5C23.25 18.26 24.26 17.25 25.5 17.25C26.74 17.25 27.75 18.26 27.75 19.5C27.75 20.74 26.74 21.75 25.5 21.75ZM25.5 18.75C25.09 18.75 24.75 19.09 24.75 19.5C24.75 19.91 25.09 20.25 25.5 20.25C25.91 20.25 26.25 19.91 26.25 19.5C26.25 19.09 25.91 18.75 25.5 18.75Z",
    fill: "#F8F8FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_9584_24078",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_9584_24078"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.172549 0 0 0 0 0.180392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9584_24078"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_9584_24078",
    result: "effect2_dropShadow_9584_24078"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9584_24078",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9584_24078",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-17 -16.5) rotate(44.1186) scale(45.9674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassKey);
export default __webpack_public_path__ + "static/media/forgotPassKey.cf24c7ebeb96faa95c026cd022fac50c.svg";
export { ForwardRef as ReactComponent };